<div class="name-id-wrapper">
  <div class="name">{{ nameValue }}</div>
  <div class="id-number">{{ idValue }}</div>
</div>
